<template>
  <validation-observer ref="updateConfiguration" #default="{ invalid }">
    <n-form-confirmation
      key="updateConfiguration"
      @submit="validateForm"
      :form="$refs.updateConfiguration"
      :disabled="invalid"
    >
      <b-card
        class="compact-card"
        v-if="isReady"
        v-for="field in fields"
        :key="field.key"
      >
        <n-input
          :fields="[field]"
          v-model="mockModel[field.key]"
          v-slot="{ model, update }"
        >
          <n-input
            v-if="field.children && model[field.key]"
            :fields="field.children"
            v-model="mockModel[field.key + '__children']"
          >
          </n-input>
        </n-input>
      </b-card>
      <b-row>
        <b-col cols="12" class="text-right">
          <n-button-loading
            type="submit"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1"
            :loading="loading"
            :disabled="invalid"
          >
            {{ $t('button.saveChanges') }}
          </n-button-loading>
        </b-col>
      </b-row>
    </n-form-confirmation>
  </validation-observer>
</template>

<script>
  import {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormRating
  } from 'bootstrap-vue';
  import Ripple from 'vue-ripple-directive';
  import NButtonLoading from '@/components/NButtonLoading';
  import NFormConfirmation from '@/components/NFormConfirmation';
  import NInput from '@/components/NInput';
  import FormInput from './updateConfiguration';
  import { mapValidationMessage } from '@/libs/helper';
  import NSingleImageUploader from '@/components/NSingleImageUploader';
  import Repository from '@/repositories/RepositoryFactory';
  const IntegrationRepository = Repository.get('integration');

  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BButton,
      BFormGroup,
      NButtonLoading,
      NFormConfirmation,
      NInput,
      NSingleImageUploader,
      BFormRating
    },
    props: {
      data: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    directives: {
      Ripple
    },
    data() {
      return {
        isReady: false,
        mockModel: {},
        loading: false
      };
    },
    mounted() {
      this.dataMapper();
      this.isReady = true;
    },
    methods: {
      dataMapper() {
        for (const field of this.fields) {
          this.mockModel[field.key] = {
            [field.key]: this.data[field.key]
          };
          if (field.children) {
            const ckey = field.key + '__children';
            this.mockModel[ckey] = {};
            for (const cfield of field.children) {
              this.mockModel[ckey][cfield.key] = this.data[cfield.key];
            }
          }
        }
      },
      formData() {
        let newData = {};
        for (const key in this.mockModel) {
          newData = { ...newData, ...this.mockModel[key] };
        }
        return newData;
      },
      validateForm() {
        this.$refs.updateConfiguration.validate().then(success => {
          if (success && this.validateMetaFields()) {
            this.submit();
          }
        });
      },
      validateMetaFields() {
        const allowedMetaFields = this.data.allowedMetaFields;
        if (allowedMetaFields) {
          const checkedField = [];
          const allowedMetaFieldsArr = allowedMetaFields.split(',');
          for (let i = 0; i < allowedMetaFieldsArr.length; i++) {
            const field = allowedMetaFieldsArr[i].trim();
            if (
              /^[a-zA-Z_][a-zA-Z0-9_]*?$/.test(field) === false ||
              checkedField.includes(field) ||
              field.length > 32
            ) {
              alert(
                this.$t('general.invalidFieldNameOf', {
                  field: field
                })
              );
              return false;
            }
            checkedField.push(field);
          }
        }
        return true;
      },
      submit() {
        this.loading = true;
        const formData = this.formData();
        IntegrationRepository.update({
          ...formData,
          userSessionExpiresIn: parseInt(
            formData.userSessionExpiresIn * 1000 * 60
          )
        })
          .catch(error => {
            console.log(error.response);
            if (error.response?.status === 422) {
              const errorMessage = mapValidationMessage(
                error.response.data.validate
              );
              this.$refs.updateConfiguration.setErrors(errorMessage);
            }
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
    setup() {
      const fields = FormInput;
      return {
        fields
      };
    }
  };
</script>

<style lang="scss" scoped>
  .compact-card {
    margin: 1rem 0;
    border: 1px solid rgba(47, 47, 47, 0.1);
    .card-body {
      padding: 1rem;
    }
  }
</style>
